import { Component, Input, OnInit } from '@angular/core';
import { NavigationConstants } from '../../utils/navigation.constants';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html'
})
export class PageHeaderComponent implements OnInit {

  @Input("pageName") pageName: string;
  pageTitle: string = ''; 

  ngOnInit(): void {
      this.pageTitle = NavigationConstants.PAGE + this.pageName;
  }


}
